export const strings = {
  en: {
    // Nav
    home: "Home",
    about: "About Us",
    work: "Our Work",
    gallery: "Gallery",
    donors: "Donors",
    contact: "Contact",
    volunteer: "Volunteer",
    donate: "Donate",
    adminLogin: "Admin",
    // Brand
    brandName: "Dharmoday",
    brandNameSub: "Seva Sansthan",
    brandNameFull: "Dharmoday Seva Sansthan",
    brandNameAlt: "धर्मोदय सेवा संस्थान",
    // Home
    heroTagline: "Nine Paths of Seva. One Rising Light.",
    brandTagline: "Our Duty — Rise of Dharma & Upliftment of All",
    heroTitle: "Serving Every Life With Dignity.",
    heroSubtitle: "Dharmoday Seva Sansthan is a registered trust working across nine pillars of seva — from feeding the poor and caring for the elderly to educating children, medical relief, empowering women, disability care, rural development, environmental protection and disaster relief.",
    ctaDonate: "Donate Now",
    ctaLearn: "Explore Our Work",
    ourPillars: "Nine Areas of Seva",
    ourPillarsSub: "Programs run by the Trust, aligned with its founding objectives",
    impactHeading: "Our Impact So Far",
    livesTouched: "Lives Touched",
    treesPlanted: "Trees Planted",
    animalsFed: "Meals Served",
    joinTitle: "Be Part of the Change",
    joinSub: "Your contribution — big or small — creates ripples of kindness.",
    // Nine areas
    a_title: "Help for the Poor",
    a_desc: "Food, clothing, shelter and essentials for the needy. Ration, medicines and community kitchens; financial aid for economically weaker families.",
    b_title: "Welfare of the Elderly",
    b_desc: "Old-age homes, shelter, food, medical care and rehabilitation for senior citizens. Day-care and assisted-living for abandoned elders.",
    c_title: "Education",
    c_desc: "Schools, colleges, libraries and hostels. Scholarships, books, uniforms and digital & vocational literacy. Skill and livelihood training centres.",
    d_title: "Medical Aid",
    d_desc: "Hospitals, clinics, dispensaries and diagnostic centres. Free medical camps, health awareness, medicines and preventive healthcare.",
    e_title: "Women & Child Welfare",
    e_desc: "Women empowerment, homes for widows and orphans, awareness against domestic violence, and education & nutrition for the girl child.",
    f_title: "Divyang (Disability) Welfare",
    f_desc: "Support for the physically and mentally disabled, rehabilitation centres, and distribution of assistive equipment.",
    g_title: "Rural Development",
    g_desc: "Rural development projects, sanitation, drinking water and infrastructure. Self-help groups and livelihood programs.",
    h_title: "Environment Protection",
    h_desc: "Tree plantation and environment conservation. Renewable energy and sustainable development. Protecting natural resources and biodiversity.",
    i_title: "Disaster Relief",
    i_desc: "Relief in natural disasters and emergencies. Rehabilitation and reconstruction of affected communities.",
    // About
    aboutHeading: "About Dharmoday Seva Sansthan",
    aboutBody: "Dharmoday — literally 'the rise of dharma' — is a registered public charitable trust founded on the belief that righteous seva, however small, can transform the world. Our objectives span nine areas: help for the poor, elderly welfare, education, medical aid, women and child welfare, disability welfare, rural development, environmental protection and disaster relief.",
    ourVision: "Our Vision",
    ourVisionBody: "A society where every human, animal, and element of nature is treated with dignity, compassion and care.",
    ourMission: "Our Mission",
    ourMissionBody: "To serve the underserved through transparent, community-led, dharmic programs — across nine areas defined in our trust deed.",
    // Donate
    donateTitle: "Give With Love",
    donateSub: "Every donation is a prayer in action. Choose your amount and cause.",
    donateName: "Full Name",
    donateEmail: "Email Address",
    donatePhone: "Phone Number",
    donateAmount: "Donation Amount (₹)",
    donatePurpose: "Purpose",
    donateShowPublicly: "Show my name on the public donors list",
    donateSubmit: "Proceed to Pay",
    // Contact
    contactTitle: "Get in Touch",
    contactSub: "We would love to hear from you.",
    subject: "Subject",
    message: "Message",
    send: "Send Message",
    // Donors
    donorsTitle: "Our Generous Donors",
    donorsSub: "Gratitude to those who make our seva possible",
    // Gallery
    galleryTitle: "Moments of Seva",
    gallerySub: "Glimpses from our work on the ground",
    // Footer
    footerTagline: "A registered trust for seva across nine areas — from the poor and elderly to environment and disaster relief.",
    quickLinks: "Quick Links",
    reach: "Reach Us",
    followUs: "Follow Us",
    allRights: "All rights reserved.",
    // Admin
    adminTitle: "Admin Dashboard",
    logout: "Logout",
    loginTitle: "Admin Login",
    email: "Email",
    password: "Password",
    login: "Login",
  },
  hi: {
    home: "होम",
    about: "हमारे बारे में",
    work: "हमारा कार्य",
    gallery: "गैलरी",
    donors: "दानदाता",
    contact: "संपर्क",
    volunteer: "स्वयंसेवक",
    donate: "दान करें",
    adminLogin: "व्यवस्थापक",
    // Brand
    brandName: "धर्मोदय",
    brandNameSub: "सेवा संस्थान",
    brandNameFull: "धर्मोदय सेवा संस्थान",
    brandNameAlt: "Dharmoday Seva Sansthan",
    heroTagline: "सेवा के नौ पथ। एक उगता प्रकाश।",
    brandTagline: "हमारा कर्तव्य — धर्मोदय एवं सर्वजनोत्थान",
    heroTitle: "हर जीवन की सेवा, गरिमा के साथ।",
    heroSubtitle: "धर्मोदय सेवा संस्थान एक पंजीकृत ट्रस्ट है जो सेवा के नौ क्षेत्रों में कार्यरत है — गरीबों की मदद, बुजुर्गों का कल्याण, शिक्षा, चिकित्सा, महिला व बाल कल्याण, दिव्यांग सेवा, ग्रामीण विकास, पर्यावरण संरक्षण और आपदा राहत।",
    ctaDonate: "अभी दान करें",
    ctaLearn: "हमारा कार्य देखें",
    ourPillars: "सेवा के नौ क्षेत्र",
    ourPillarsSub: "ट्रस्ट के उद्देश्यों के अनुरूप चलाए जाने वाले कार्यक्रम",
    impactHeading: "अब तक का हमारा प्रभाव",
    livesTouched: "जीवन स्पर्शित",
    treesPlanted: "वृक्ष लगाए",
    animalsFed: "भोजन वितरित",
    joinTitle: "परिवर्तन का हिस्सा बनें",
    joinSub: "आपका छोटा-सा योगदान करुणा की लहरें बनाता है।",
    a_title: "गरीबों की मदद",
    a_desc: "गरीब और जरूरतमंद लोगों को भोजन, कपड़े, आश्रय और आवश्यक चीज़ें। राशन, दवाइयाँ और सामुदायिक रसोई; कमजोर वर्ग को आर्थिक सहायता।",
    b_title: "बुजुर्गों का कल्याण",
    b_desc: "वृद्धाश्रम, आश्रय, भोजन, चिकित्सा और पुनर्वास। दिव्यांग/अकेले बुज़ुर्गों के लिए डे-केयर व असिस्टेड लिविंग।",
    c_title: "शिक्षा",
    c_desc: "स्कूल, कॉलेज, पुस्तकालय व हॉस्टल। छात्रवृत्ति, किताबें, यूनिफ़ॉर्म, डिजिटल व व्यवसायिक शिक्षा तथा कौशल विकास।",
    d_title: "चिकित्सा सहायता",
    d_desc: "अस्पताल, क्लिनिक, डिस्पेंसरी व डायग्नोस्टिक सेंटर। नि:शुल्क शिविर, दवाइयाँ, स्वास्थ्य जागरूकता और स्वच्छता पहल।",
    e_title: "महिला और बाल कल्याण",
    e_desc: "महिला सशक्तिकरण, विधवा व अनाथ बच्चों के लिए घर, घरेलू हिंसा के विरुद्ध कार्यक्रम, लड़कियों की शिक्षा व पोषण।",
    f_title: "दिव्यांग कल्याण",
    f_desc: "शारीरिक व मानसिक रूप से दिव्यांग लोगों की सहायता, पुनर्वास केंद्र और सहायक उपकरणों का वितरण।",
    g_title: "ग्रामीण विकास",
    g_desc: "ग्रामीण विकास परियोजनाएँ, स्वच्छता, पेयजल व बुनियादी ढाँचा। स्वयं-सहायता समूह व आजीविका कार्यक्रम।",
    h_title: "पर्यावरण संरक्षण",
    h_desc: "पेड़-पौधे लगाना, पर्यावरण संरक्षण। नवीकरणीय ऊर्जा और टिकाऊ विकास। प्राकृतिक संसाधनों व जैव-विविधता की रक्षा।",
    i_title: "आपदा राहत",
    i_desc: "प्राकृतिक आपदा व आपातकालीन स्थितियों में राहत, पुनर्वास व पुनर्निर्माण कार्य।",
    aboutHeading: "धर्मोदय सेवा संस्थान के बारे में",
    aboutBody: "धर्मोदय — अर्थात् 'धर्म का उदय' — एक पंजीकृत सार्वजनिक धर्मार्थ ट्रस्ट है। हमारा विश्वास है कि सत्कर्म, चाहे कितना भी छोटा हो, संसार को बदल सकता है। हमारे उद्देश्य नौ क्षेत्रों में फैले हैं — गरीबों की मदद, बुजुर्गों का कल्याण, शिक्षा, चिकित्सा, महिला-बाल कल्याण, दिव्यांग कल्याण, ग्रामीण विकास, पर्यावरण और आपदा राहत।",
    ourVision: "हमारा दृष्टिकोण",
    ourVisionBody: "एक ऐसा समाज जहाँ हर मनुष्य, पशु और प्रकृति गरिमा और करुणा से जिये।",
    ourMission: "हमारा उद्देश्य",
    ourMissionBody: "पारदर्शी, सामुदायिक और धर्ममूलक कार्यक्रमों के माध्यम से ट्रस्ट के नौ उद्देश्यों की पूर्ति।",
    donateTitle: "प्रेम से दें",
    donateSub: "हर दान एक जीवित प्रार्थना है। अपनी राशि और कारण चुनें।",
    donateName: "पूरा नाम",
    donateEmail: "ईमेल पता",
    donatePhone: "फ़ोन नंबर",
    donateAmount: "दान राशि (₹)",
    donatePurpose: "उद्देश्य",
    donateShowPublicly: "मेरा नाम सार्वजनिक दानदाता सूची में दिखाएँ",
    donateSubmit: "भुगतान करें",
    contactTitle: "संपर्क करें",
    contactSub: "हमें आपसे बात करके ख़ुशी होगी।",
    subject: "विषय",
    message: "संदेश",
    send: "संदेश भेजें",
    donorsTitle: "हमारे उदार दानदाता",
    donorsSub: "उन सभी को आभार जिनकी वजह से हमारी सेवा संभव है",
    galleryTitle: "सेवा के क्षण",
    gallerySub: "हमारे कार्य की झलकियाँ",
    footerTagline: "नौ क्षेत्रों में सेवा हेतु पंजीकृत ट्रस्ट — गरीब, बुज़ुर्ग, शिक्षा, चिकित्सा से लेकर पर्यावरण व आपदा राहत तक।",
    quickLinks: "त्वरित लिंक",
    reach: "हम तक पहुँचें",
    followUs: "हमें फ़ॉलो करें",
    allRights: "सर्वाधिकार सुरक्षित।",
    adminTitle: "व्यवस्थापक डैशबोर्ड",
    logout: "लॉगआउट",
    loginTitle: "व्यवस्थापक लॉगिन",
    email: "ईमेल",
    password: "पासवर्ड",
    login: "लॉगिन",
  }
};

export const areas = [
  { key: "a", Icon: "HandCoins", color: "#C95B24", bg: "#FCEAD9" },
  { key: "b", Icon: "Home", color: "#5B4023", bg: "#F0E6D2" },
  { key: "c", Icon: "GraduationCap", color: "#0F5972", bg: "#DDEFF7" },
  { key: "d", Icon: "Stethoscope", color: "#8B1E3F", bg: "#F7D9E1" },
  { key: "e", Icon: "Baby", color: "#8E3B1D", bg: "#F7E0DA" },
  { key: "f", Icon: "Accessibility", color: "#4B2E83", bg: "#E4DEF3" },
  { key: "g", Icon: "Sprout", color: "#1B4332", bg: "#DCEEDA" },
  { key: "h", Icon: "TreePine", color: "#2F6B3A", bg: "#DCEEDA" },
  { key: "i", Icon: "LifeBuoy", color: "#B8391A", bg: "#F7DCD4" },
];
